import * as React from 'react'
import '@/mkt_machpro/pages/coupon/MyCoupon/index.css'
import { IndexPath, SectionList } from '@wmfe/mach-pro-components-react'
import KNB from '@wmfe/mach-pro-knb'
import { uniq, isEmpty, compact } from 'lodash'
import { CouponItem, CouponUpgradeModal } from '@sailor/marketing-growth-components'
import EmptyView from '@Pages/coupon/components/EmptyView'
import { reportRaptorMetrics } from '@Common/SLRaptor'
import { ModuleLxType, pageTracker, moduleTracker } from '@/common/lx'
import { jumpTo, getUserLocation } from '@/common/utils'
import { CouponsRequest, MyCouponsExchangeRequest, CouponUpgradeRequest, CouponDowngradeRequest } from '@/mkt_machpro/pages/coupon/service'
import { couponListRequest, bannerDowngradeSwitch, myCouponExchange, TypeRequest, couponUpgrade, couponDowngrade, getJumpToUrl } from '@/mkt_machpro/pages/coupon/service/api'
import { CouponInfo, CouponExchangeDetail, CouponBizLineEnum } from '@/mkt_machpro/pages/coupon/service/model'
import { SCHEME_MACHPRO_WITH_PRE } from '@/mkt_machpro/pages/coupon/constants'
import { PageSourceEnum } from '@/mkt_machpro/pages/coupon/MyCoupon/constants'
import { PageSourceType, CouponPackType, SaleChannel, InflateCouponType } from '@/mkt_machpro/pages/coupon/constants/CouponConstant'
import JudasConstant from '@/mkt_machpro/pages/coupon/constants/JudasConstant'
import i18nClient from '@/mkt_machpro/pages/coupon/MyCoupon/i18n.config'
import NavigateBar from '@/components/NavigateBar'
import MyCouponListBanner from '@/mkt_machpro/pages/coupon/MyCoupon/components/MyCouponListBanner'
import MyCouponResourceBanner from '@/mkt_machpro/pages/coupon/MyCoupon/components/MyCouponResourceBanner'
import MyCouponPromoDialog from '@/mkt_machpro/pages/coupon/MyCoupon/components/MyCouponPromoDialog'
import RedeemToast from '@/mkt_machpro/pages/coupon/MyCoupon/components/RedeemToastView'

const Login = Mach.requireModule('Login')
let isLogin = Login?.isLogin?.()
const Toast = Mach.requireModule('Toast')

interface IState {
  loading: boolean
  hasMore: boolean
  emptyText: string | string[]
  couponList: any[]
  promoDialogVisible: boolean
  isFirstPromoDialog: boolean // 是否是首次打开兑换弹窗
  promoFailTips: string
  showRedeemToast: boolean
  initedListRequest: boolean
  defaultUseCouponLink: string
  resourceDemote: boolean
  commonToastInfo: {
    imageUrl?: string
    message?: string
  }
  // 膨胀券相关数据
  couponUpgradeModalVisible: boolean // 膨胀弹窗是否展示
  couponDowngradeModalVisible: boolean // 逆膨弹窗是否展示
  couponUpgradeModalData: any // 膨胀弹窗数据
}

/**
 * 我的-优惠券列表
 */
export default class MyCouponListApp extends React.Component<any, IState> {
  sectionListRef: any

  pageIndex = 0

  exposedIndexPathMap: Set<string> = new Set()

  exchangeCouponArr: any[] = []

  renderStartTime = 0

  isInited = false

  /** 当前选中的膨胀券或逆膨券 */
  currentUpgradeCoupon: any = {}

  /** 膨胀接口返回的膨后券信息 */
  upgradeInfo = {
    toCouponViewId: '',
    upgradeButtonUrl: '',
  }

  constructor (props: object) {
    super(props)
    this.state = {
      loading: false,
      hasMore: false,
      emptyText: [i18nClient.getText('coupon_display_list_default_text')],
      couponList: [],
      promoDialogVisible: Boolean(Mach.env?.schemeParams?.pageSource === PageSourceEnum.HOME_PRE_SEARCH && Mach.env?.schemeParams?.code), // 首页搜索直跳兑券
      isFirstPromoDialog: true,
      promoFailTips: '',
      showRedeemToast: false,
      initedListRequest: false,
      defaultUseCouponLink: '',
      resourceDemote: false,
      commonToastInfo: {
        imageUrl: '',
        message: '',
      },
      couponUpgradeModalVisible: false,
      couponDowngradeModalVisible: false,
      couponUpgradeModalData: {},
    }
  }

  componentDidMount () {
    // 上报券列表曝光量
    reportRaptorMetrics({ coupon_list_pv: 1 })
    if (isLogin) {
      this.renderStartTime = Date.now()
      this.reqCouponList()
    } else {
      // 上报passport调起登陆次数
      reportRaptorMetrics({ passport_need_login: 1 })
      // 调起登陆
      KNB &&
        KNB?.login({
          success (result) {
            // 上报passport登陆成功回调
            reportRaptorMetrics({ passport_login: 1 }, { status: 1 })
          },
          fail (error: any) {
            // 上报passport登陆失败回调
            reportRaptorMetrics({ passport_login: 0 }, { status: 2, errorCode: error?.errorCode, errorMsg: error?.errorMsg, result: error?.result })
          },
        })
      this.addLoginChangeObserver()
    }
    // this.bannerResourceDowngradeSwitch()
    pageTracker({ cid: JudasConstant.MY_COUPON_LIST_CID })
    moduleTracker({ type: ModuleLxType.MV, cid: JudasConstant.MY_COUPON_LIST_CID, bid: JudasConstant.MY_COUPON_HISTORY_ENTRY_MV })
  }

  componentDidUpdate (prevProps: Readonly<any>, prevState: Readonly<IState>): void {
    if (prevState.couponList !== this.state.couponList && !this.isInited) {
      this.isInited = true
      const duration = Date.now() - this.renderStartTime
      // 上报券列表渲染时长
      reportRaptorMetrics({ couponList_render_cost_time: duration }, { costTime: duration })
    }
  }

  /**
   * 资源位banner降级
   * **/
  bannerResourceDowngradeSwitch = async () => {
    try {
      // 获取资源位接口参数
      const resourceParams: any = {
        channelId: '10097',
        version: Mach.env.bundleVersion,
      }
      let res = await bannerDowngradeSwitch(resourceParams)
      // 判断是否降级用新的资源位组件还是老的
      const isShowDemote = [0, 1].includes(res?.data)
      this.setState({ resourceDemote: isShowDemote })
    } catch (e) {
      // 如果降级开关获取失败，默认开启新的资源位
      this.setState({ resourceDemote: true })
    }
  }

  /**
   * 登录成功后
   */
  addLoginChangeObserver = () => {
    const eventOfLogin = Login?.eventOfLogin()
    return Mach.requireModule('EventCenter').addListener(eventOfLogin, () => {
      isLogin = Login?.isLogin?.()
      try {
        this.pageIndex = 0
        this.renderStartTime = Date.now()
        this.reqCouponList()
      } catch (error) {
        console.log(error)
      }
    })
  }

  afterInit (hasList: boolean) {
    if (!hasList) {
      moduleTracker({ type: ModuleLxType.MV, cid: JudasConstant.MY_COUPON_LIST_CID, bid: 'b_waimai_c_overseas_klb8hwq9_mv' }) // 无券mv
    }
    this.setState({ initedListRequest: true })
  }

  reqCouponList = () => {
    const pageSource = Mach.data?.pageSource || '' // 页面来源
    const topSortCouponViewId = Mach.data?.topSortCouponViewId || '' // 置顶券列表
    const couponViewIdList = uniq(compact(topSortCouponViewId.split(',')))
    // 入参构造
    let couponsReqParams: CouponsRequest = {
      couponStatus: TypeRequest.MY_COUPONS,
      page: this.pageIndex,
      pageSize: 20,
    }
    if (!isEmpty(couponViewIdList) && this.pageIndex === 0) {
      couponsReqParams = {
        ...couponsReqParams,
        topSortCouponViewId: couponViewIdList,
      }
    }
    this.setState({
      loading: true,
    })
    // 接口请求
    couponListRequest(couponsReqParams)
      .then(result => {
        this.exchangeCouponArr = new Array(result?.couponList.length).fill(false)
        this.setState({
          hasMore: result.hasMore,
          defaultUseCouponLink: result.defaultUseCouponLink,
          couponList: result?.couponList,
          loading: false,
        })
        this.afterInit(result?.couponList?.length > 0)
        if (result?.hasMore === false) {
          this.reportCouponCount(result?.couponList)
        }
      })
      .catch(error => {
        if (error === 'error') {
          this.setState({
            emptyText: i18nClient.getText('coupon_display_list_access_error_text'),
            loading: false,
          })
        } else {
          this.setState({
            emptyText: [i18nClient.getText('coupon_display_list_default_text')],
            loading: false,
          })
        }
        this.afterInit(false)
      })
    this.pageIndex += 1
  }

  renderItem = (item: any) => {
    const indexPath = item.indexPath
    const lab = this.getCommonLab(item?.data, indexPath)
    const { couponList } = this.state
    return (
      <view className="coupon-container">
        <CouponItem
          data={item?.data}
          showScene="my_coupon_list"
          isExchangeCoupon={this.exchangeCouponArr[indexPath.item]}
          isLastOne={indexPath.item + 1 === (couponList || []).length}
          itemsMargin="12"
          defaultUseCouponLink={this.state.defaultUseCouponLink}
          i18nClient={i18nClient}
          showUpgradeBtn
          showDowngradeBtn
          onUseButtonClick={() => {
            this.handleUseButtonClick(indexPath.item, item?.data, indexPath)
          }}
          onRuleIconClick={() => {
            moduleTracker({ cid: JudasConstant.MY_COUPON_LIST_CID, bid: JudasConstant.MY_COUPON_COUPON_RULE_MC, valLab: lab })
          }}
          onRuleCloseBtnClick={() => {
            moduleTracker({ cid: JudasConstant.MY_COUPON_LIST_CID, bid: JudasConstant.MY_COUPON_COUPON_RULE_CLOSE_MC, valLab: lab })
          }}
          onUpgradeBtnClick={() => this.handleCouponListUpgradeBtnClick(item?.data, indexPath)}
          onDowngradeBtnClick={() => this.handleCouponListDowngradeBtnClick(item?.data, indexPath)}
          onUpgradeBtnView={() => {
            reportRaptorMetrics({ UPGRADE_BTN_MV: 1 }, { source: SaleChannel.PERSON_COUPON_LIST_PAGE, coupon_id: item?.data?.couponBaseInfoDto?.couponConfigId })
          }}
          onDowngradeBtnView={() => {
            reportRaptorMetrics({ DOWNGRADE_BTN_MV: 1 }, { source: SaleChannel.PERSON_COUPON_LIST_PAGE, coupon_id: item?.data?.couponBaseInfoDto?.couponConfigId })
          }}
        />
      </view>
    )
  }

  /**
   * 点击去使用按钮，跳转优惠券页面
   */
  handleUseButtonClick = async (item: number, couponInfo: CouponInfo, indexPath: any) => {
    const { couponDisplayInfoDto, couponBaseInfoDto } = couponInfo
    // 点击埋点
    const lab = {
      coupon_id: couponBaseInfoDto.couponConfigId,
      coupon_index: indexPath.item,
      coupon_name: couponDisplayInfoDto.name,
      coupon_status: 0,
    }
    moduleTracker({ cid: JudasConstant.MY_COUPON_LIST_CID, bid: JudasConstant.MY_COUPON_USE_BUTTON_MC, valLab: lab })
  }

  /**
   * 跳转历史优惠券页面
   */
  jumpHistoryCouponPage = () => {
    // 点击埋点
    moduleTracker({ cid: JudasConstant.MY_COUPON_LIST_CID, bid: JudasConstant.MY_COUPON_HISTORY_ENTRY_MC })
    // 页面跳转
    const bundleName = 'mach_pro_sailor_c_market_history_coupon_list'
    const data = { pageSource: PageSourceType.MY_COUPON_LIST }
    jumpTo({
      urlInfo: {
        url: SCHEME_MACHPRO_WITH_PRE,
        query: {
          mach_bundle_name: bundleName,
        },
      },
      customParam: data,
      // onSuccess: () => {
      //   console.log('成功')
      // },
      // onError: error => {
      //   console.log('失败', error)
      // },
    })
  }

  onPullUp = () => {
    if (!this.state.hasMore) {
      return
    }
    this.setState({
      loading: true,
    })
    const couponsReqParams: CouponsRequest = {
      couponStatus: TypeRequest.MY_COUPONS,
      page: this.pageIndex,
      pageSize: 20,
    }
    couponListRequest(couponsReqParams)
      .then(result => {
        const oldOrderList = this.state.couponList
        const newOrderList = result?.couponList
        const orderList = [...oldOrderList, ...newOrderList]
        this.exchangeCouponArr = this.exchangeCouponArr.concat(new Array(newOrderList.length).fill(false))
        this.setState({
          loading: false,
          hasMore: result.hasMore,
          couponList: orderList,
          defaultUseCouponLink: result.defaultUseCouponLink,
          emptyText: [i18nClient.getText('coupon_display_list_default_text')],
        })
        if (result?.hasMore === false) {
          this.reportCouponCount(orderList)
        }
      })
      .catch(error => {
        if (error === 'error') {
          this.setState({
            emptyText: i18nClient.getText('coupon_display_list_access_error_text'),
          })
        } else {
          this.setState({
            emptyText: [i18nClient.getText('coupon_display_list_default_text')],
          })
        }
      })
    this.pageIndex += 1
  }

  sectionData = () => {
    const { couponList } = this.state
    const sections = []
    if (couponList && couponList.length > 0) {
      // @ts-ignore
      sections.push({
        data: this.state.couponList,
      })
    }
    return sections
  }

  onCellAppear = (indexPath: any) => {
    const couponInfo = this.state.couponList[indexPath.item]
    const couponViewId = couponInfo?.couponBaseInfoDto ? couponInfo?.couponBaseInfoDto?.couponViewId : null

    if (!couponViewId) {
      return
    }
    if (!this.exposedIndexPathMap.has(couponViewId)) {
      this.exposedIndexPathMap.add(couponViewId)
      const lab = this.getCommonLab(couponInfo, indexPath)
      const couponConfigId = couponInfo?.couponBaseInfoDto?.couponConfigId
      const isInflateCoupon = couponInfo?.couponDisplayInfoDto?.inflateCouponDisplayInfo?.inflateCouponType === InflateCouponType.INFLATED
      const couponLab = {
        ...lab,
        coupon_id: isInflateCoupon ? -999 : couponConfigId,
        upgraded_coupon_id: isInflateCoupon ? couponConfigId : -999,
      }
      moduleTracker({ type: ModuleLxType.MV, cid: JudasConstant.MY_COUPON_LIST_CID, bid: JudasConstant.MY_COUPON_COUPON_MV, valLab: couponLab })
    }
  }

  getCommonLab = (couponInfo: CouponInfo, indexPath: any) => {
    const couponDisplayInfo = couponInfo?.couponDisplayInfoDto
    const couponConfigId = couponInfo?.couponBaseInfoDto?.couponConfigId
    const lab = {
      coupon_amount: couponDisplayInfo?.couponAmountString,
      coupon_id: couponConfigId,
      coupon_index: indexPath?.item,
      coupon_min_price: couponDisplayInfo?.sillAmountString,
      coupon_name: couponDisplayInfo?.name,
      coupon_status: 0,
    }
    return lab
  }

  /**
   * 打开兑换弹窗
   */
  openPromoDialog = () => {
    moduleTracker({ cid: JudasConstant.MY_COUPON_LIST_CID, bid: JudasConstant.MY_COUPON_EXCHANGE_ENTRY_MC })
    this.setState({
      promoDialogVisible: true,
      promoFailTips: '',
    })
  }

  /**
   * 关闭兑换弹窗
   */
  closePromoDialog = () => {
    this.setState({
      promoDialogVisible: false,
      promoFailTips: '',
      isFirstPromoDialog: false,
    })
  }

  /**
   * 提交兑换码
   */
  commitPromoCode = (keyword: string) => {
    // 入参构造
    const { actualLatitude, actualLongitude } = getUserLocation()
    const exchangeRequest: MyCouponsExchangeRequest = {
      exchangeCode: keyword,
      idempotentKey: String(Mach.env.networkTimestamp()),
      actualLatitude: actualLatitude,
      actualLongitude: actualLongitude,
    }
    // 接口请求
    return myCouponExchange(exchangeRequest)
      .then(result => {
        // 兑换成功，关闭弹窗
        this.setState(
          {
            promoDialogVisible: false,
            isFirstPromoDialog: false,
          },
          () => {
            const inputRemainder = i18nClient.getText('coupon_promocode_showlist_sucess_toast')
            this.setState({
              showRedeemToast: true,
              commonToastInfo: {
                imageUrl: 'https://img-ap-hongkong.mykeeta.net/sailorc/f3c452b3e4a74bf55e73c07f6a97fcc96207.png',
                message: inputRemainder,
              },
            })
            setTimeout(() => {
              this.closeRedeemToast()
            }, 2000)
            moduleTracker({ type: ModuleLxType.MV, cid: JudasConstant.MY_COUPON_LIST_CID, bid: JudasConstant.MY_COUPON_EXCHANGE_TOAST_MV, valLab: { coupon_id: result?.couponConfigId } })
          },
        )
        const couponViewIdList = uniq(compact(result.map((item: CouponExchangeDetail) => item.couponViewId)))
        // 刷新列表
        if (!isEmpty(couponViewIdList)) {
          this.setState({
            loading: true,
          })
          const couponsReqParams: CouponsRequest = {
            couponStatus: TypeRequest.MY_COUPONS,
            page: 0,
            pageSize: 20,
            topSortCouponViewId: couponViewIdList,
          }
          couponListRequest(couponsReqParams)
            .then(result => {
              this.exchangeCouponArr = new Array(result?.couponList.length).fill(false).map((item, index) => !!couponViewIdList[index])
              this.setState(
                {
                  loading: false,
                  hasMore: result?.hasMore,
                  couponList: result?.couponList,
                  defaultUseCouponLink: result.defaultUseCouponLink,
                  emptyText: [i18nClient.getText('coupon_display_list_default_text')],
                },
                () => {
                  this.sectionListRef?.scrollToItem(
                    {
                      section: 0,
                      item: 0,
                    },
                    {
                      animated: true,
                    },
                  )
                },
              )
            })
            .catch(error => {
              if (error === 'error') {
                this.setState({
                  emptyText: i18nClient.getText('coupon_display_list_access_error_text'),
                })
              } else {
                this.setState({
                  emptyText: [i18nClient.getText('coupon_display_list_default_text')],
                })
              }
            })
        }
      })
      .catch(error => {
        let message = error
        if (error === 'error') {
          message = i18nClient.getText('coupon_display_list_access_error_text')
        }
        // 兑换失败，刷新弹窗失败文案
        KNB.vibrate({
          duration: 1000,
        })
        this.setState({
          promoFailTips: message,
        })
      })
  }

  /**
   * 关闭兑换Toast
   */
  closeRedeemToast = () => {
    this.setState({
      showRedeemToast: false,
    })
  }

  /**
   * 渲染新版资源位
   * **/
  renderResourceBanner = () => {
    // ----- mpweb适配origin -----
    // if (isLogin) {
    // ----- mpweb适配change -----
    if (isLogin && !Mach.env.isH5) {
      // ----- mpweb适配       -----
      return <MyCouponResourceBanner />
    }
    return null
  }

  /**
   * 上报用户优惠券数量&售卖券数量
   */
  reportCouponCount = (couponList: CouponInfo[]) => {
    try {
      if (!Array.isArray(couponList)) return

      const { couponTotalCount, sellCouponTotalCount, keemartCouponTotalCount } = couponList.reduce(
        (pre, cur) => {
          const curCount = cur.couponDisplayInfoDto?.count || 0
          return {
            couponTotalCount: pre.couponTotalCount + curCount,
            sellCouponTotalCount: pre.sellCouponTotalCount + (cur.couponBaseInfoDto?.packSceneId === CouponPackType.SELL ? curCount : 0),
            keemartCouponTotalCount: pre.keemartCouponTotalCount + (cur.couponBaseInfoDto?.bizLine === CouponBizLineEnum.KEEMART ? curCount : 0),
          }
        },
        { couponTotalCount: 0, sellCouponTotalCount: 0, keemartCouponTotalCount: 0 },
      )

      // 上报用户优惠券数量
      reportRaptorMetrics({ user_coupon_totalcount: couponTotalCount }, { count: couponTotalCount })
      // 上报用户售卖券数量
      reportRaptorMetrics({ user_sell_coupon_totalcount: sellCouponTotalCount }, { count: sellCouponTotalCount })
      // 上报用户小象券数量
      reportRaptorMetrics({ user_keemart_coupon_totalcount: keemartCouponTotalCount }, { count: keemartCouponTotalCount })
    } catch (error) {
      console.log('function reportCouponCount: 上报用户优惠券数量失败', error)
    }
  }

  /**
   * 券列表-膨胀按钮点击处理
   */
  handleCouponListUpgradeBtnClick = (couponInfo: CouponInfo, indexPath: any) => {
    const { couponBaseInfoDto, couponDisplayInfoDto } = couponInfo
    this.currentUpgradeCoupon = couponInfo
    this.setState({
      couponUpgradeModalVisible: true,
      couponUpgradeModalData: {
        title: `${i18nClient.getText('upgraded_title', 'Koupon upgraded!')}`, // 主标题
        inflateCouponInfo: couponDisplayInfoDto?.inflateCouponDisplayInfo, // 膨胀券信息，与券系统保持一致
        originalCouponInfo: {
          // 当前券信息
          couponAmount: couponDisplayInfoDto?.couponAmountString, // 券面额，单位元
          sillAmount: couponDisplayInfoDto?.sillAmountString, // 券门槛，单位元
          currencyCode: couponDisplayInfoDto?.currencyType, // 货币符号
          couponConfigId: couponBaseInfoDto?.couponConfigId, // 券配置id
        },
      },
    })
    // 膨胀按钮点击埋点
    const lab = this.getCommonLab(couponInfo, indexPath)
    moduleTracker({ cid: JudasConstant.MY_COUPON_LIST_CID, bid: JudasConstant.MY_COUPON_UPGRADE_BUTTON_MC, valLab: lab })
    reportRaptorMetrics({ UPGRADE_BTN_MC: 1 }, { source: SaleChannel.PERSON_COUPON_LIST_PAGE, coupon_id: couponBaseInfoDto?.couponConfigId })
  }

  /**
   * 膨胀弹窗-膨胀按钮点击
   */
  handleUpgradeBtnClick = (): Promise<boolean> => {
    const { couponBaseInfoDto, couponDisplayInfoDto } = this.currentUpgradeCoupon
    const { actualLatitude, actualLongitude, latitude, longitude } = getUserLocation()
    const params: CouponUpgradeRequest = {
      upgradeCouponInfo: {
        fromCouponConfigId: couponBaseInfoDto?.couponConfigId,
        fromCouponViewId: couponBaseInfoDto?.couponViewId,
        upgradeAfterInfoList: [
          {
            toCouponConfigId: couponDisplayInfoDto?.inflateCouponDisplayInfo?.upgradeCouponConfigId?.[0],
            sellInfo: {
              sillAmount: couponDisplayInfoDto?.inflateCouponDisplayInfo?.upgradeSillAmount,
              couponAmount: couponDisplayInfoDto?.inflateCouponDisplayInfo?.upgradeAmount,
            },
          },
        ],
      },
      source: SaleChannel.PERSON_COUPON_LIST_PAGE,
      riskApiCommonParam: {
        actualLongitude,
        actualLatitude,
        homePageLongitude: longitude,
        homePageLatitude: latitude,
      },
    }
    // 弹窗膨胀按钮点击上报
    reportRaptorMetrics({ EXPANSION_COUPON_CLICK: 1 }, { source: SaleChannel.PERSON_COUPON_LIST_PAGE, coupon_id: couponBaseInfoDto?.couponConfigId })
    return couponUpgrade(params)
      .then(result => {
        if (result?.code === 0) {
          this.upgradeInfo.toCouponViewId = result?.data?.upgradeInfo?.[0]?.upgradeAfterInfoList?.[0]?.toCouponViewId
          this.upgradeInfo.upgradeButtonUrl = result?.data?.upgradeInfo?.[0]?.upgradeAfterInfoList?.[0]?.buttonUrl
          // 膨胀接口调用上报
          reportRaptorMetrics({ EXPANSION_COUPON_API: 1 }, { source: SaleChannel.PERSON_COUPON_LIST_PAGE, status: 1, code: result?.code, message: result?.msg })
          return true
        } else {
          if (result?.code === 103) {
            // 若加码金额变更，则刷新弹窗中的加码金额
            result?.msg && Toast.show(result?.msg, 2)
            const sellInfo = result?.data?.upgradeInfo?.[0]?.upgradeAfterInfoList?.[0]?.sellInfo || {}
            this.setState(prevState => {
              // 更新膨胀弹窗展示数据、当前券的膨胀金额和门槛(不刷新券列表然后搜索更新是因为券列表做了分页，刷新后不一定能找到当前券)
              const index = prevState.couponList.findIndex(item => item.couponBaseInfoDto.couponViewId === this.currentUpgradeCoupon.couponBaseInfoDto.couponViewId)
              if (index === -1 || !sellInfo) {
                return null
              }
              const updatedCouponList = prevState.couponList.map((item, idx) => {
                if (idx === index) {
                  return {
                    ...item,
                    couponDisplayInfoDto: {
                      ...item.couponDisplayInfoDto,
                      inflateCouponDisplayInfo: {
                        ...item.couponDisplayInfoDto.inflateCouponDisplayInfo,
                        upgradeAmount: sellInfo.couponAmount,
                        upgradeSillAmount: sellInfo.sillAmount,
                        upgradeAmountText: sellInfo.showCouponAmount,
                        upgradeSillAmountText: sellInfo.showSillAmount,
                      },
                    },
                  }
                }
                return item
              })
              return {
                couponUpgradeModalData: {
                  ...prevState.couponUpgradeModalData,
                  inflateCouponInfo: {
                    ...prevState.couponUpgradeModalData.inflateCouponInfo,
                    upgradeAmount: sellInfo?.couponAmount,
                    upgradeSillAmount: sellInfo?.sillAmount,
                    upgradeAmountText: sellInfo?.showCouponAmount,
                    upgradeSillAmountText: sellInfo?.showSillAmount,
                  },
                },
                couponList: updatedCouponList,
              }
            })
            this.currentUpgradeCoupon.couponDisplayInfoDto.inflateCouponDisplayInfo.upgradeAmount = sellInfo?.couponAmount
            this.currentUpgradeCoupon.couponDisplayInfoDto.inflateCouponDisplayInfo.upgradeSillAmount = sellInfo?.sillAmount
          } else {
            setTimeout(() => {
              // 兼容安卓toast不展示
              Toast.show(i18nClient.getText('koupon_bug', '系统正忙，请重试'), 2)
            }, 0)
            this.setState({
              couponUpgradeModalVisible: false,
            })
            this.pageIndex = 0
            this.reqCouponList()
          }
          // 膨胀接口调用上报
          reportRaptorMetrics({ EXPANSION_COUPON_API: 0 }, { source: SaleChannel.PERSON_COUPON_LIST_PAGE, status: 0, code: result?.code, message: result?.msg })
          return false
        }
      })
      .catch(error => {
        setTimeout(() => {
          // 兼容安卓toast不展示
          Toast.show(i18nClient.getText('koupon_bug', '系统正忙，请重试'), 2)
        }, 0)
        this.setState({
          couponUpgradeModalVisible: false,
        })
        this.pageIndex = 0
        this.reqCouponList()
        // 膨胀接口调用上报
        reportRaptorMetrics({ EXPANSION_COUPON_API: 0 }, { source: SaleChannel.PERSON_COUPON_LIST_PAGE, status: 0, message: 'error' })
        return false
      })
  }

  /**
   * 膨胀弹窗-使用按钮点击处理
   */
  handleUpgradeApplyBtnClick = () => {
    this.setState(
      {
        couponUpgradeModalVisible: false,
      },
      async () => {
        const { defaultUseCouponLink } = this.state
        const { longitude, latitude, actualLatitude, actualLongitude } = getUserLocation()
        const needAsyncUrl = !this.upgradeInfo.upgradeButtonUrl
        // 页面跳转
        if (needAsyncUrl) {
          const url = await getJumpToUrl({
            couponViewId: this.upgradeInfo.toCouponViewId,
            longitude,
            latitude,
            actualLatitude,
            actualLongitude,
            defaultUseCouponLink,
          })
          jumpTo({
            urlInfo: {
              url,
            },
          })
        } else {
          jumpTo({
            urlInfo: {
              url: this.upgradeInfo.upgradeButtonUrl,
            },
          })
        }
      },
    )
  }

  /**
   * 膨胀弹窗-关闭按钮(膨后)点击处理
   */
  handlePostUpgradeCloseBtnClick = () => {
    this.setState({
      couponUpgradeModalVisible: false,
    })
    this.pageIndex = 0
    this.reqCouponList()
  }

  /**
   * 券列表-逆膨按钮点击处理
   */
  handleCouponListDowngradeBtnClick = (couponInfo: CouponInfo, indexPath: any) => {
    const { couponBaseInfoDto, couponDisplayInfoDto } = couponInfo
    this.currentUpgradeCoupon = couponInfo
    this.setState({
      couponDowngradeModalVisible: true,
      couponUpgradeModalData: {
        inflateCouponInfo: couponDisplayInfoDto?.inflateCouponDisplayInfo, // 膨胀券信息，与券系统保持一致
        originalCouponInfo: {
          // 当前券信息
          couponAmount: couponDisplayInfoDto?.couponAmountString, // 券面额，单位元
          sillAmount: couponDisplayInfoDto?.sillAmountString, // 券门槛，单位元
          currencyCode: couponDisplayInfoDto?.currencyType, // 货币符号
          couponConfigId: couponBaseInfoDto?.couponConfigId, // 券配置id
        },
      },
    })
    // 逆膨按钮点击埋点
    const lab = this.getCommonLab(couponInfo, indexPath)
    const couponConfigId = couponInfo?.couponBaseInfoDto?.couponConfigId
    const isInflateCoupon = couponInfo?.couponDisplayInfoDto?.inflateCouponDisplayInfo?.inflateCouponType === InflateCouponType.INFLATED
    const couponLab = {
      ...lab,
      coupon_id: isInflateCoupon ? -999 : couponConfigId,
      upgraded_coupon_id: isInflateCoupon ? couponConfigId : -999,
    }
    moduleTracker({ cid: JudasConstant.MY_COUPON_LIST_CID, bid: JudasConstant.MY_COUPON_DOWNGRADE_BUTTON_MC, valLab: couponLab })
    reportRaptorMetrics({ DOWNGRADE_BTN_MC: 1 }, { source: SaleChannel.PERSON_COUPON_LIST_PAGE, coupon_id: couponBaseInfoDto?.couponConfigId })
  }

  /**
   * 逆膨弹窗-逆膨按钮点击
   */
  handleDowngradeBtnClick = () => {
    const { couponBaseInfoDto } = this.currentUpgradeCoupon
    const { actualLatitude, actualLongitude, latitude, longitude } = getUserLocation()
    const params: CouponDowngradeRequest = {
      fromCouponViewId: couponBaseInfoDto?.couponViewId,
      source: SaleChannel.PERSON_COUPON_LIST_PAGE,
      riskApiCommonParam: {
        actualLongitude,
        actualLatitude,
        homePageLongitude: longitude,
        homePageLatitude: latitude,
      },
    }
    // 弹窗逆膨按钮点击上报
    reportRaptorMetrics({ EXPANSION_REVERSE_COUPON_CLICK: 1 }, { source: SaleChannel.PERSON_COUPON_LIST_PAGE, coupon_id: couponBaseInfoDto?.couponConfigId })
    couponDowngrade(params)
      .then(result => {
        setTimeout(() => {
          // 兼容安卓toast不展示
          Toast.show(i18nClient.getText('koupon1_reverse_wording', '逆膨成功'), 2)
        }, 0)
        this.setState({
          couponDowngradeModalVisible: false,
        })
        this.pageIndex = 0
        this.reqCouponList()
        // 逆膨接口调用上报
        reportRaptorMetrics({ EXPANSION_REVERSE_COUPON_API: 1 }, { source: SaleChannel.PERSON_COUPON_LIST_PAGE, status: 1, code: result?.code, message: result?.msg })
      })
      .catch(error => {
        setTimeout(() => {
          // 兼容安卓toast不展示
          Toast.show(i18nClient.getText('koupon_bug', '系统正忙，请重试'), 2)
        }, 0)
        this.setState({
          couponDowngradeModalVisible: false,
        })
        this.pageIndex = 0
        this.reqCouponList()
        // 膨胀接口调用上报
        reportRaptorMetrics({ EXPANSION_REVERSE_COUPON_API: 0 }, { source: SaleChannel.PERSON_COUPON_LIST_PAGE, status: 0, code: error?.code, message: error?.msg || error })
      })
  }

  /**
   * 获取膨胀弹窗组件的埋点配置
   */
  getCouponUpgradeLxConfig = () => ({
    cid: JudasConstant.MY_COUPON_LIST_CID,
    preUpgrade: {
      mvBid: JudasConstant.MY_COUPON_UPGRADE_MODAL_PREUPGRADE_MV,
      mcBid: JudasConstant.MY_COUPON_UPGRADE_MODAL_PREUPGRADE_MC,
    },
    postUpgrade: {
      mvBid: JudasConstant.MY_COUPON_UPGRADE_MODAL_POSTUPGRADE_MV,
    },
  })

  render () {
    const rightComponent = (
      <view className="title-right-container" onClick={() => this.jumpHistoryCouponPage()}>
        <text className="history-coupon-text">{i18nClient.getText('coupon_list_page_history_title')}</text>
      </view>
    )
    const leftComponent = (
      <view className="title-left-container">
        <text className="left-coupon-text">{i18nClient.getText('coupon_list_page_title')}</text>
      </view>
    )
    const {
      loading,
      hasMore,
      couponList,
      emptyText,
      promoDialogVisible,
      isFirstPromoDialog,
      promoFailTips,
      showRedeemToast,
      commonToastInfo,
      resourceDemote,
      couponUpgradeModalVisible,
      couponDowngradeModalVisible,
      couponUpgradeModalData,
    } = this.state
    const hasCouponList = couponList && (couponList || []).length > 0
    const isShowEmptyView = !loading && !hasCouponList
    const isShowResourceBanner = isShowEmptyView && isLogin

    return (
      <view className="app">
        {/* <NavigationBar title="" leftComponent={leftComponent} rightComponent={rightComponent} /> */}
        <NavigateBar leftTitle={i18nClient.getText('coupon_list_page_title')} rightComponent={rightComponent} />

        <view className="list-wrap">
          {/* 兑换入口*/}
          <view className="exchange-code-container">
            <view className="exchange-wapper" onClick={() => this.openPromoDialog()}>
              <image src="assets://icon/coupon/icon_exchange_code.png" className="exchange-icon" autoRTL />
              <text className="exchange-hint-text">{i18nClient.getText('coupon_promocode_enterbar')}</text>
            </view>
          </view>
          {/* {isLogin && !resourceDemote && <MyCouponListBanner emptyList={isShowEmptyView} waitReportMv={!this.state.initedListRequest} />} */}
          {/* {isLogin && this.renderResourceBanner()} */}
          {isShowResourceBanner && this.renderResourceBanner()}
          {/* 列表区*/}
          {!isShowEmptyView && (
            <view className="container">
              <view className="refresh-wrap">
                <refresh loading={loading} hasMore={hasMore} pullUpEnable pullDownEnable={false} onPullUp={this.onPullUp}>
                  <SectionList
                    ref={ref => {
                      this.sectionListRef = ref
                    }}
                    headerView={this.renderResourceBanner}
                    itemKey={(item: any) => item?.couponBaseInfoDto?.couponViewId ?? 'NULL'}
                    renderItem={this.renderItem}
                    showScrollIndicator={false}
                    sections={this.sectionData()}
                    onCellAppear={this.onCellAppear}
                    loading={this.state.loading}
                    cellHeightCacheKey={(indexPath: IndexPath) => {
                      const { item } = indexPath || {}
                      if (item) {
                        const couponInfo = this.state.couponList[item]
                        return `${indexPath.item}+${indexPath.section}+${couponInfo?.couponBaseInfoDto?.couponViewId}`
                      }
                      return ''
                    }}
                  />
                </refresh>
              </view>
            </view>
          )}

          {/* 兜底区*/}
          {isShowEmptyView && (
            <view className="empty-wrap">
              <EmptyView emptyText={emptyText} />
            </view>
          )}

          {/* 兑换弹窗*/}
          {promoDialogVisible && (
            <MyCouponPromoDialog
              defaultKeyWord={isFirstPromoDialog ? Mach.env?.schemeParams?.code : undefined}
              promoFailTips={promoFailTips}
              onClickCloseBtn={this.closePromoDialog}
              onClickCommitBtn={this.commitPromoCode}
            />
          )}
        </view>

        {/* 兑换成功Toast*/}
        {showRedeemToast && <RedeemToast imageUrl={commonToastInfo.imageUrl} message={commonToastInfo.message} />}

        {/* 膨胀弹窗 */}
        {couponUpgradeModalVisible && (
          <CouponUpgradeModal
            data={couponUpgradeModalData}
            source={SaleChannel.PERSON_COUPON_LIST_PAGE}
            i18nClient={i18nClient}
            lxConfig={this.getCouponUpgradeLxConfig()}
            onUpgradeBtnClick={this.handleUpgradeBtnClick}
            onApplyBtnClick={this.handleUpgradeApplyBtnClick}
            onPreUpgradeCloseBtnClick={() => this.setState({ couponUpgradeModalVisible: false })}
            onPostUpgradeCloseBtnClick={this.handlePostUpgradeCloseBtnClick}
          />
        )}

        {/* 逆膨弹窗 */}
        {couponDowngradeModalVisible && (
          <CouponUpgradeModal
            data={couponUpgradeModalData}
            source={SaleChannel.PERSON_COUPON_LIST_PAGE}
            i18nClient={i18nClient}
            downGrade
            onDowngradeBtnClick={this.handleDowngradeBtnClick}
            onPreUpgradeCloseBtnClick={() => this.setState({ couponDowngradeModalVisible: false })}
          />
        )}
      </view>
    )
  }
}
